module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'propertiesForm',
    ],

    config: {
        entityContext: 'projectTerms',
        updateTabTitleForFieldCodes: {
            title: true,
            startTS: true,
        },
        updateTabTitleControllerLocator: '< base_tabStrip_tabStrip > templates_office_projectTerms_controller',
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_projectTerms': true,
        },
    },
}